import {API_BASE_URL, PATH_ACCESSES, PATH_ACCESSES_ALL} from '../constants/constants';
import {request, getFiltersAsQuery} from "./APIService";

export function getAccessesByClientId(showAll, range, clientId, page, size, filters) {
    let q = getFiltersAsQuery(filters);
    return request({
        url: API_BASE_URL + PATH_ACCESSES + (showAll ? PATH_ACCESSES_ALL : '') + '?range=' + range + '&clientId=' + clientId + '&page=' + page + '&size=' + size + '&q=' + q,
        method: 'GET'
    }, []);
}


// WEBPACK FOOTER //
// ./src/app/services/AccessesService.js